import { render } from "./legoMultiDropdown.vue?vue&type=template&id=4ff82f62"
import script from "./legoMultiDropdown.vue?vue&type=script&lang=js"
export * from "./legoMultiDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/lego/extend/legoMultiDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ff82f62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ff82f62', __exports__)) {
    api.reload('4ff82f62', __exports__)
  }
  
  module.hot.accept("./legoMultiDropdown.vue?vue&type=template&id=4ff82f62", () => {
    api.rerender('4ff82f62', render)
  })

}


export default __exports__